export default "__VITE_ASSET__HLCoJzdC__"